import React, {PropTypes} from 'react';
import style from './BasicPhone.scss';

export class BasicPhone extends React.Component {
  static propsType = {
    hideOverflow: PropTypes.bool.isRequired,
    className: PropTypes.string,
    children: PropTypes.node.isRequired
  };

  static defaultProps = {
    hideOverflow: false,
    children: ''
  };

  render() {
    const {hideOverflow, className, children} = this.props;

    return (
      <div className={style.root + ' ' + className}>
        <div className={style.content + ' ' + (hideOverflow ? style.hideOverflow : '')}>
          {children}
          </div>
      </div>
    );
  }
}

export default BasicPhone;



// WEBPACK FOOTER //
// ./src/themes/components/BasicPhone/BasicPhone.js